<template>
  <v-expansion-panel-content
    :key="id"
    expand-icon=""
    class="content-bg--2 fill-height"
  >
    <template #header v-if="['xs'].includes($vuetify.breakpoint.name)">
      <div class="font-weight-medium pr-0">
        <v-layout
          class="font-weight-bold align-center justify-space-between display-1"
        >
          {{ item.name }}
          <v-btn @click.native.stop="openDialog" icon class="text-xs-center">
            <icon-dots size="17"></icon-dots>
          </v-btn>
        </v-layout>
        <div>
          <div
            v-if="item.start && item.end && new Date(item.end) < new Date()"
            :class="dateClass"
            class="display-0 pl-1 pb-2 font-weight-medium text--secondary subtitle-2"
          >
            С {{ start }} по {{ end }} (завершена)
          </div>
          <div
            v-else-if="item.start && item.end"
            :class="dateClass"
            class="display-0 pl-1 pb-2 font-weight-medium text--secondary subtitle-2"
          >
            С {{ start }} по {{ end }}
          </div>
          <div
            v-else
            :class="dateClass"
            class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
          ></div>
        </div>
        <div>
          <icon-angle size="10" class="icon-angle mr-1"></icon-angle>
          Статистика
        </div>
      </div>
    </template>

    <v-layout
      column
      justify-space-between
      ma-0
      class="content-bg--2 text-xs-left pb-5 pt-4 px-4 fill-height"
    >
      <v-layout
        class="display-1 font-weight-bold align-center justify-space-between pa-3"
        v-if="!['xs'].includes($vuetify.breakpoint.name)"
      >
        <span class="d-inline-block text-truncate">
          {{ item.name }}
        </span>
        <button
          @click="delAdv"
          class="link align-self-end"
          v-if="!['xs'].includes($vuetify.breakpoint.name)"
        >
          <icon-close></icon-close>
        </button>
      </v-layout>

      <div
        v-if="item.start && item.end && new Date(item.end) < new Date()"
        :class="dateClass"
        class="display-0 pl-1 pb-2 font-weight-medium text--secondary subtitle-2"
      >
        С {{ start }} по {{ end }} (завершена)
      </div>
      <div
        v-else-if="item.start && item.end"
        :class="dateClass"
        class="display-0 pl-1 pb-2 font-weight-medium text--secondary subtitle-2"
      >
        С {{ start }} по {{ end }}
      </div>
      <div
        v-else
        :class="dateClass"
        class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
      ></div>

      <v-flex
        v-if="!['xs'].includes($vuetify.breakpoint.name)"
        xs12
        md12
        class="display-0 font-weight-medium pl-0 pb-1 mb-4 v-flex v-flex--border subtitle-2"
      >
        <span class="text-no-wrap">
          <v-btn
            :to="{ name: 'advSettings', params: { id: id } }"
            icon
            class="ma-0"
          >
            <icon-pencil></icon-pencil>
          </v-btn>
        </span>
        Изменить
        <span class="text-no-wrap">
          <v-btn @click="copyAdv" icon class="ma-0">
            <icon-copy></icon-copy>
          </v-btn>
        </span>
        Дублировать
      </v-flex>

      <div
        class="adv-item-filters fill-height"
        :class="{ 'd-block': ['xs'].includes($vuetify.breakpoint.name) }"
      >
        <v-flex
          md6
          sm6
          class="subtitle-2 pt-2 pl-0 text--secondary font-weight-medium hotspot"
          :class="{ 'pr-0 pt-0': ['xs'].includes($vuetify.breakpoint.name) }"
        >
          <label>Адрес</label>
          <div
            v-if="hotspots.length === 1"
            class="display-0 pt-1 mt-1 pb-3 font-weight-medium subtitle-2 text--primary text-capitalize text-truncate"
          >
            {{ hotspots[0].address }}
          </div>
          <v-select
            v-if="hotspots.length !== 1"
            @change="getStats()"
            :items="hotspots"
            height="32"
            item-value="id"
            item-text="address"
            v-model="hotspot_id"
            class="pb-3 adv-hotspot"
            append-icon=""
            hide-details
            dense
            solo
          >
            <template #append>
              <icon-angle
                class="ma-0 link"
                :color="
                  $store.getters.themeDark
                    ? $vuetify.theme.primary
                    : $vuetify.theme.theme
                "
              ></icon-angle>
            </template>
            <template v-slot:selection="{ item }">
              <div class="ellipsis text-capitalize">
                {{ item.address ? item.address : item.title }}
              </div>
            </template>
            <template v-slot:item="{ item }">
              <div class="ellipsis text-capitalize">
                {{ item.address ? item.address : item.title }}
              </div>
            </template>
          </v-select>
        </v-flex>

        <v-flex
          md6
          class="subtitle-2 pt-2 pl-0 text--secondary font-weight-medium adv-datepicker"
          :class="{ 'pr-0': ['xs'].includes($vuetify.breakpoint.name) }"
        >
          <label> За период </label>
          <date-range-picker
            :range="range"
            :index="index"
            @update="changeDate($event)"
          ></date-range-picker>
        </v-flex>
      </div>

      <v-flex xs12 class="pt-2 pb-4 font-weight-medium text-xs-right">
        <advertising-chart
          :graphData="graphData"
          v-if="graphLoad"
        ></advertising-chart>
      </v-flex>

      <v-flex
        xs12
        class="pt-2 pl-0 font-weight-medium text-xs-right subtitle-2"
      >
        <div class="pb-2 pt-2 square-border">
          Всего ответов: {{ watchs + skips }}
        </div>
        <div class="pb-2 pt-2 square-border text-xs-left">
          <div class="square-green"></div>
          <span>Перешли по ссылке</span>
          <span v-if="watchs > 0" class="adv-counts">
            {{ ((watchs / (watchs + skips)) * 100).toFixed(2) }}% ({{ watchs }})
          </span>
        </div>
        <div class="pb-2 pt-2 square-border text-xs-left">
          <div>
            <div class="square-red"></div>
            <span>Закрыли рекламу</span>
            <span v-if="skips > 0" class="adv-counts">
              {{ ((skips / (watchs + skips)) * 100).toFixed(2) }}% ({{ skips }})
            </span>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialogDrawer" content-class="adv-dialog">
      <v-card class="content-bg--2">
        <div class="font-weight-bold display-1 pl-3 pr-2 pt-4">
          {{ item.name }}
        </div>
        <div class="pl-3 py-2">
          <div
            v-if="item.start && item.end && new Date(item.end) < new Date()"
            :class="dateClass"
            class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
          >
            С {{ start }} по {{ end }} (завершена)
          </div>
          <div
            v-else-if="item.start && item.end"
            :class="dateClass"
            class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
          >
            С {{ start }} по {{ end }}
          </div>
          <div
            v-else
            :class="dateClass"
            class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
          ></div>
        </div>
        <v-divider></v-divider>
        <div class="pl-3 pr-4 pt-3 pb-4">
          <div class="py-1 pl-2">
            <icon-pencil class="mr-4"></icon-pencil>
            <v-btn
              :to="{ name: 'advSettings', params: { id: id } }"
              icon
              class="ma-0"
            >
              <span class="ml-3">Изменить</span>
            </v-btn>
          </div>
          <div class="pt-1 pl-2">
            <icon-copy class="mr-4"></icon-copy>
            <v-btn @click="copyAdv" icon>
              <span class="ml-4">Дублировать</span>
            </v-btn>
          </div>
          <div class="py-1 pl-2">
            <icon-close class="mr-3"></icon-close>
            <v-btn @click="delAdv" icon>
              <span>Удалить</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-expansion-panel-content>
</template>

<script>
import AdvertisingChart from "./AdvertisingChart.vue";
import IconClose from "../icon/IconClose.vue";
import IconPencil from "../icon/IconPencil.vue";
import IconAngle from "../icon/IconAngle.vue";
import IconCopy from "../icon/IconCopy.vue";
import IconDots from "../icon/IconDots";
import moment from "moment";
import requestApi from "../../modules/requestApi";
import Common from "../../modules/common";
import DateRangePicker from "../common/DateRangePicker.vue";

export default {
  components: {
    AdvertisingChart,
    IconAngle,
    IconPencil,
    IconClose,
    IconCopy,
    IconDots,
    DateRangePicker,
  },

  props: {
    height: {
      type: Number,
      default: 100,
    },
    id: {
      type: Number,
      required: true,
    },
    // порядковый номер карточки на экране
    index: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    graphLoad: false,
    range: { startDate: null, endDate: null },
    hotspots: [],
    answers: [
      { name: "Перешли по ссылке", value: 20 },
      { name: "Закрыли рекламу", value: 30 },
    ],
    skips: 0,
    watchs: 0,
    hotspot_id: "",
    graphData: [
      { name: "Перешли по ссылке", value: 0 },
      { name: "Закрыли рекламу", value: 0 },
    ],
    dialogDrawer: false,
  }),

  computed: {
    item() {
      let item = this.$store.getters.getAdv(this.id);
      return item;
    },
    // для отображения периода рекламы
    start() {
      return moment(this.item.start).format("DD.MM.YYYY");
    },
    end() {
      return moment(this.item.end).format("DD.MM.YYYY");
    },
    // для фильтрации статистики
    dateClass() {
      let endDate = new Date(this.item.end);
      let startDate = new Date(this.item.start);
      let now = new Date();
      if (endDate < now) {
        return "adv-date-end";
      } else if (endDate > now && now > startDate) {
        return "adv-date-now";
      } else {
        return "adv-date";
      }
    },
  },

  mounted() {
    this.getStats();
    this.getHotspots();
  },

  methods: {
    getHotspots: async function () {
      await requestApi
        .advHotspotList({ advertising_id: this.item.id })
        .then((res) => {
          this.hotspots = res;
        });
    },
    getStats: async function () {
      this.graphLoad = false;
      this.skips = 0;
      this.watchs = 0;
      await requestApi
        .advStatsList({
          advertising_id: this.item.id,
          hotspot_id: this.hotspot_id,
          range: this.range,
        })
        .then((res) => {
          res.forEach((item) => {
            switch (item.status) {
              case 1:
                this.watchs += +item.cnt;
                break;
              case 2:
                this.skips += +item.cnt;
                break;
              case 3:
                this.skips += +item.cnt;
                break;
            }
          });
          this.$set(this.graphData[0], "value", this.watchs);
          this.$set(this.graphData[1], "value", this.skips);
          Common.sendMetrika("period");
          this.graphLoad = true;
        });
    },
    delAdv() {
      this.$store.dispatch("deleteAdv", { id: this.item.id }).then(() => {
        this.$store.dispatch("popupInfoOpen", {
          text: "Реклама успешно удалена",
          timeout: 180000,
          action: {
            name: "Восстановить",
            method: "recoveryAdv",
            textThen: "Реклама успешно восстановлена",
            param: { id: this.id },
          },
        });
      });
    },
    copyAdv() {
      let params = { ...this.item };
      delete params.id;
      params.name += " (копия)";
      this.$store.dispatch("copyAdv", params).then(() => {
        // открываем сообщение
        this.$store.dispatch("popupInfoOpen", {
          text: "Реклама успешно добавлена",
        });
      });
    },
    openDialog() {
      this.dialogDrawer = true;
    },
    closeDialog() {
      this.dialogDrawer = false;
    },
    /**
     * Очищает инпут календаря к исходным значениям
     */
    clearInput() {
      if (this.range.startDate && this.range.endDate) {
        this.range.startDate = null;
        this.range.endDate = null;
        this.getStats();
      }
    },
    // обновляем дату и запрашиваем статистику
    changeDate(range) {
      this.range = range;
      this.getStats();
    },
  },
};
</script>
